"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = __importStar(require("react"));
var SvgStatusLightBulbSmall = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 16, height: 22, xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M3.196 13.598c.555.47.924 1.108 1.057 1.803h3.23v-4.524a2.544 2.544 0 0 1-1.905-2.459h1.27a1.271 1.271 0 0 0 2.54 0h1.269c0 1.181-.81 2.177-1.905 2.46V15.4h3.231a3.172 3.172 0 0 1 1.067-1.812 7.609 7.609 0 0 0 2.685-5.805c0-6.829-8.328-10.182-13.07-5.31a7.607 7.607 0 0 0 .531 11.124ZM8.117 21.834c1.4 0 2.54-1.139 2.54-2.54H5.578c0 1.401 1.14 2.54 2.54 2.54ZM4.309 16.67h7.617v1.355H4.31v-1.354Z", fill: "#fff" }) }))); };
exports.default = SvgStatusLightBulbSmall;
